// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__9GZKo","spin":"styles_spin__3K5uA"};